import {
  type AutocompleteArrayInputProps,
  AutocompleteArrayInput,
  useGetList,
} from "react-admin";

import { type ModuleValue } from "@/types/modules";

type Props = Omit<AutocompleteArrayInputProps, "resource"> & {
  module: ModuleValue;
};

const STALE_TIME = 60_000;

export const ReferenceAutoCompleteArrayInput = ({ module, ...rest }: Props) => {
  const { isPending, data } = useGetList(
    module,
    { filter: { pagination: false } },
    {
      staleTime: STALE_TIME,
    },
  );

  return (
    <AutocompleteArrayInput
      {...rest}
      isPending={isPending}
      choices={data ?? []}
    />
  );
};
